const formatUnit = (unit: string): string => {
  if (unit === "MONTH") {
    return "months";
  }

  if (unit === "YEAR") {
    return "years";
  }

  return unit;
};

export default formatUnit;
